import anime from "animejs";

const flipcards = (function () {
	'use strict';
	let nodes = document.querySelectorAll('.flip-cards__toggle');
	let playing = false;

	const methods = {};

	const flip = (card) => {
		if (playing)
			return;

		let front = card.querySelector('.flip-cards__front');
		let back = card.querySelector('.flip-cards__back');
		let newSide, oldSide;

		if (back.hasAttribute('aria-hidden')) {
			oldSide = front;
			newSide = back;
		} else {
			newSide = front;
			oldSide = back;
		}

		newSide.removeAttribute('hidden');
		newSide.removeAttribute('aria-hidden');

		playing = true;
		anime({
			targets: card,
			scale: [{ value: 1 }, { value: 1.05 }, { value: 1, delay: 250 }],
			rotateY: { value: '+=180', delay: 200 },
			easing: 'easeInOutSine',
			duration: 400,
			complete: function (anim) {
				playing = false;
				oldSide.hidden = true;
				oldSide.setAttribute('aria-hidden', true);
			}
		});
	};

	methods.init = () => {
		const cards = Array.from(nodes);

		cards.map((item) => {
			item.addEventListener('click', (e) => {
				flip(item);
			})
			item.addEventListener('keypress', (e) => {
				if (e.code === 'Enter' || e.code === 'Space') {
					e.preventDefault();
					flip(item);
				}
			})
		})
	}

	return methods;
})();

export default flipcards;